var file_upload_viewer_default = {
  "fontElementMap": "_4LPkI",
  "file_upload_container": "uu0Ju",
  "file_upload_link": "RV03N",
  "file_upload_error_container": "PE-LR",
  "file_upload_file_info": "ufeeU",
  "file_upload_type_icon": "lrrj-",
  "file_upload_status_icon_container": "SJK9Z",
  "file_upload_status_icon": "CEtcN",
  "file_upload_description": "_3VRHP",
  "file_upload_name_container": "sh9yW",
  "file_upload_name": "_2eoX7",
  "file_upload_extension": "_3gBZw",
  "file_loader_icon": "ZjUPl",
  "file_upload_icon_frame": "Ir6-t",
  "file_upload_icon_background": "NPDWK"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
